import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Image,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { RiFoldersLine } from "@remixicon/react";
import { useEffect, useRef, useState } from "react";
import SmrHistoryItem from "./smroom_history_item";
import { Virtuoso } from "react-virtuoso";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { contentRemove, selectContentsAll } from "@/reducer/contentSlice";
import SmrDeleteModal from "./deletemodal";
import { Content } from "@/types/content";
import Client4 from "@/services/api/client4";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";
import SmrHistoryModal from "./smroom_history_modal";

const SmrHistory = () => {
  const dispatch = useAppDispatch();
  const [isShowHistoryList, setIsshowHistoryList] = useState(true);
  const virtuosoRef = useRef<any>(null);
  const [imgIndex, setImgIndex] = useState(-1);
  const [currentContentId, setCurrentContentId] = useState("");
  const deleteControl = useDisclosure();
  const smrHistoryControl = useDisclosure();

  const contents = useAppSelector(selectContentsAll);
  // const contents = contentsAll.filter(item=> item.mode === "毛坯房出图");
  const currentImage = useAppSelector(selectCurrentImage);

  const handleToggleHostoryList = () => {
    setIsshowHistoryList((prevState) => !prevState);
  };

  const OnDelete = (contentId: string) => {
    setCurrentContentId(contentId);
    deleteControl.onOpen();
  };

  const handleOnDelete = () => {
    dispatch(contentRemove(currentContentId));
    Client4.deleteContent(currentContentId);
    // if(currentImage.id === currentContentId){
    //   dispatch(setCurrentImage({} as Content ));
    // }
    if (currentImage.id === currentContentId) {
      contents.map((item, index) => {
        if (item.id === currentImage.id && index < contents.length - 1) {
          dispatch(setCurrentImage(contents[index + 1]));
        } else if (
          item.id === currentImage.id &&
          index === contents.length - 1
        ) {
          // dispatch(setCurrentImage(contents[0]));
          dispatch(setCurrentImage({} as Content ));
        }
      });
      
    }
    deleteControl.onClose();
  };

  const handleClickBatch = () => {
    smrHistoryControl.onOpen();
  }

  useEffect(() => {
    if (virtuosoRef.current?.scrollTo) {
      virtuosoRef.current.scrollTo({ top: 0 });
    }
  }, [contents]);

  return (
    <Flex w="100%" h={"100%"} flexDirection="column">
      <Flex
        pr="10px"
        w="100%"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Button
          variant={"unstyle"}
          rightIcon={
            isShowHistoryList ? <ChevronUpIcon /> : <ChevronDownIcon />
          }
          color={"white"}
          fontSize="14px"
          onClick={handleToggleHostoryList}
        >
          创作记录
        </Button>
        <Tooltip label="批量操作" placement="top">
          <IconButton
            aria-label="delete img"
            size="xs"
            variant="unstyle"
            color={"#6C7596"}
            icon={<RiFoldersLine size="20px" />}
            _hover={{ color: "#8E94A9" }}
            onClick={handleClickBatch}
          />
        </Tooltip>
      </Flex>
      <Box flex={1} h="0">
        {isShowHistoryList && (
          <Box h="100%" p="10px" overflow={"auto"}>
            {/* 暂无作品 */}
            {contents.length === 0 && (
              <Flex
                h="108px"
                borderRadius="10px"
                bg="#161922"
                color={"#6C7596"}
                fontSize="12px"
                justifyContent={"center"}
                alignItems="center"
              >
                暂无作品
              </Flex>
            )}
            {/* 图片列表 */}
            {contents.length > 0 && (
              <Virtuoso
                style={{ height: "100%" }}
                ref={virtuosoRef}
                data={contents}
                followOutput={true}
                itemContent={(index, item) => (
                  <Box
                    // width="100%"
                    position={"relative"}
                    key={index}
                    display={"block"}
                    ml="10px"
                    boxSizing="border-box"
                  >
                    <SmrHistoryItem content={item} onDelete={OnDelete} />
                  </Box>
                )}
              />
            )}
          </Box>
        )}
      </Box>

      <SmrDeleteModal
        isOpen={deleteControl.isOpen}
        onClose={deleteControl.onClose}
        onDelete={handleOnDelete}
      />
      <SmrHistoryModal
      isOpen={smrHistoryControl.isOpen}
      onClose={smrHistoryControl.onClose}
      onDelete={OnDelete} />
    </Flex>
  );
};

export default SmrHistory;
